import axios from "axios";
import { authHeaderJson, authHeaderJsonIntegrationFG } from "../auth-header.service";

const getDocumentTeachDownload = (documentUrlList) => {
    return axios.post(`/api/documentteach/documentdownload`, documentUrlList, { headers: authHeaderJson() } )
};

const getDocumentTeachStructure = () => {
    return axios.get(`/api/documentteach/documentstructure`, { headers: authHeaderJson() } );
};

const getDocumentTeachFiles = (path) => {
    return axios.get(`/api/documentteach/documents?path=${encodeURIComponent(path)}`, { headers: authHeaderJson() });
};

export {
    getDocumentTeachStructure,
    getDocumentTeachDownload,
    getDocumentTeachFiles
}